// components/Auth/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const accessToken =
    localStorage.getItem('access_token') || sessionStorage.getItem('access_token');

  if (!accessToken) {
    // Redirect to login page if no token found
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
